module.exports = __webpack_public_path__ + "static/house2-068313adf0bf2dd11d985c5179555105.jpg";